function _jade_template_fn(locals) {
  locals = locals || {};;;
  var result_of_with = (function($attr, $component, $helpers, JSON) {
    var h = require("panel").h;
    return {
      value: (h("div", {
        "class": {
          'mp-breakdown-menu': true,
          'mp-query-block-multi-list': true
        },
      }, (function() {
        var __jade_nodes = [];
        const selectedEvent = $helpers.getSelectedEvent();;
        __jade_nodes = __jade_nodes.concat((selectedEvent) ? ((function() {
          var __jade_nodes = [];
          const propMenuConfig = {
            attrs: {
              'open': $attr(`open`),
              'event-names': JSON.stringify([selectedEvent.value]),
              'project-id': $attr(`project-id`),
              'workspace-id': $attr(`workspace-id`),
            },
            on: {
              select: $helpers.handleSelectProperty
            },
          };;
          __jade_nodes = __jade_nodes.concat($component.child(`mp-properties-menu`, propMenuConfig));;
          return __jade_nodes
        }).call(this)) : ((function() {
          var __jade_nodes = [];
          const eventMenuConfig = {
            attrs: {
              'open': $attr(`open`),
              'data-group-id': $attr(`data-group-id`),
              'project-id': $attr(`project-id`),
              'workspace-id': $attr(`workspace-id`),
            },
            on: {
              select: $helpers.handleSelectEvent
            },
          };;
          __jade_nodes = __jade_nodes.concat($component.child(`mp-events-menu`, eventMenuConfig));;
          return __jade_nodes
        }).call(this)));;
        return __jade_nodes
      }).call(this).filter(Boolean)))
    };
  }.call(this, "$attr" in locals ? locals.$attr : typeof $attr !== "undefined" ? $attr : undefined, "$component" in locals ? locals.$component : typeof $component !== "undefined" ? $component : undefined, "$helpers" in locals ? locals.$helpers : typeof $helpers !== "undefined" ? $helpers : undefined, "JSON" in locals ? locals.JSON : typeof JSON !== "undefined" ? JSON : undefined));
  if (result_of_with) return result_of_with.value;
}
module.exports = _jade_template_fn;